module.exports = __webpack_public_path__ + "e6b959bdab85209501229b39c3f53c93.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/benefit-workout-exp.png
// module id = 564
// module chunks = 0